import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { get } from '../utils/api';

async function getSearch({ search, limit }) {
  const res = await get('/search', { params: { q: search, limit } });
  return res?.data;
}

export function useSearchQuery({ search, limit = 10, offset = 0 }) {
  const {
    data: _data,
    isLoading,
    error,
  } = useQuery(['search', search], () => getSearch({ search, limit, offset }), {
    enabled: !!search,
    keepPreviousData: true,
  });

  const data = useMemo(
    () => _data || { files: [], meetings: [], folders: [], meetingTexts: [] },
    [_data]
  );

  return {
    ...data,
    isLoading,
    error,
  };
}
